import _ from 'lodash';

import type { ErrorFieldType } from '@/types';

/** Valide le format d'un numéro de téléphone */
const validatePhone = (phone: string): ErrorFieldType[] => {
  const errors: ErrorFieldType[] = [];

  let tel = _.replace(phone, '_', '');
  tel = _.replace(tel, /\s/g, '');

  // S'il n'est pas complet on va pas plus loib
  if (_.size(tel) !== 10) {
    errors.push({ id: 'telephone', message: 'Le numéro doit contenir 10 chiffres' });

    return errors;
  }

  // Commence par 0, suivi de 1 à 9, suivi de 4 groupes de 2 chiffres
  const phoneRegex = /^0[1-9]([-. ]?[0-9]{2}){4}$/;

  const valid = phoneRegex.test(tel);

  // S'il n'est pas valide, on renvoi l'erreur précise
  // (s'il n'est pas complet, s'il contient des caractères spéciaux, etc.)
  if (!valid) {
    if (!/^[0-9]*$/.test(tel)) {
      errors.push({ id: 'telephone', message: 'Le numéro ne doit contenir que des chiffres' });
    } else {
      errors.push({ id: 'telephone', message: 'Le format du numéro est invalide' });
    }
  }

  return errors;
};

export default validatePhone;
